import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Table, Icon } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import Page from '../../../internal/Page'
import { getText } from '../../../internal/TextLabels'
import PrintModalUI from '../../PayApply/pages/shared/PrintModalUI'

const DocumentsUI = ({ documents }) => {
  const [documentUrl, setDocumentUrl] = useState(null)

  return (
    <>
      <Page title={getText('support.pages.docs.title')}>
        <Table>
          <thead>
            <tr>
              <th>{getText('support.docs.columnHeader.description')}</th>
              <th>{getText('support.docs.columnHeader.fileType')}</th>
            </tr>
          </thead>
          <tbody>
            {documents?.map(doc => (
              <tr
                className={midas.hand}
                key={doc.url}
                onClick={() => setDocumentUrl(doc.url)}
              >
                <td>
                  <span
                    style={{
                      display: 'inline-block',
                      paddingRight: '1rem',
                      verticalAlign: 'middle',
                    }}
                  >
                    <Icon name="midasFileDownload" />
                  </span>
                  {doc.caption}
                </td>
                <td>{doc.extension}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Page>
      {documentUrl && (
        <PrintModalUI
          url={documentUrl}
          closeText={getText('default.close')}
          onClose={() => setDocumentUrl(null)}
          show
        />
      )}
    </>
  )
}

DocumentsUI.propTypes = {
  documents: PropTypes.array.isRequired,
}

export default DocumentsUI
